import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function FormLabelDescription({ children, className }) {
    return (_jsx("p", { className: cn('text-sm text-gray-600 mb-1', className), children: children }));
}
